import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SigninOidcComponent } from './signin-oidc.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SigninOidcComponent],
  exports: [SigninOidcComponent],
})
export class SigninOidcModule {}
